import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "no-gutters text-center pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  property: "itemListElement",
  typeof: "ListItem"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    property: "item",
    typeof: "WebPage",
    title: "Go to EveryLink.",
    href: "/",
    class: "home"
  }, [
    /*#__PURE__*/_createElementVNode("span", { property: "name" }, "EveryLink")
  ]),
  /*#__PURE__*/_createElementVNode("meta", {
    property: "position",
    content: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  property: "itemListElement",
  typeof: "ListItem"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > "),
  /*#__PURE__*/_createElementVNode("a", {
    property: "item",
    typeof: "WebPage",
    title: "Go to EveryLink.",
    href: "/people",
    class: "home"
  }, [
    /*#__PURE__*/_createElementVNode("span", { property: "name" }, "People")
  ]),
  /*#__PURE__*/_createElementVNode("meta", {
    property: "position",
    content: "1"
  })
], -1)
const _hoisted_4 = {
  property: "itemListElement",
  typeof: "ListItem"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > ", -1)
const _hoisted_6 = {
  key: 1,
  property: "name"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("meta", {
  property: "position",
  content: "3"
}, null, -1)
const _hoisted_8 = { class: "my-5" }
const _hoisted_9 = { class: "d-flex justify-content-center" }
const _hoisted_10 = { class: "row no-gutters" }
const _hoisted_11 = { class: "col-12 text-center" }
const _hoisted_12 = {
  key: 1,
  class: "d-inline-block align-middle"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "text-center"
}
const _hoisted_15 = {
  key: 1,
  class: "text-center"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 0,
  class: "home"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  key: 1,
  class: "home"
}
const _hoisted_20 = {
  key: 0,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeletor = _resolveComponent("Skeletor")!
  const _component_PostCard = _resolveComponent("PostCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeletor, {
              key: 0,
              class: "d-inline-block",
              width: "140",
              height: "15"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getFullName), 1)),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeletor, {
              key: 0,
              class: "my-3",
              circle: "",
              size: "120"
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "avatar my-3",
              style: _normalizeStyle({ backgroundImage: `url(${_ctx.getAvatar})` })
            }, null, 4))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_Skeletor, {
                key: 0,
                class: "mx-auto mb-2",
                width: "300",
                height: "35"
              }))
            : (_openBlock(), _createElementBlock("h2", _hoisted_12, _toDisplayString(_ctx.getFullName), 1))
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeletor, {
              key: 0,
              class: "mx-auto",
              width: "100",
              height: "35",
              pill: ""
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (!_ctx.isFriend)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendFriendRequest && _ctx.sendFriendRequest(...args))),
                      class: "btn btn-lg btn-primary"
                    }, "Invite")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("a", {
                      href: `people/chat?id=${_ctx.person.wpId}`,
                      class: "btn btn-lg btn-primary"
                    }, "Chat", 8, _hoisted_16)
                  ]))
            ]))
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
              return _createElementVNode("div", {
                key: index,
                class: "col-12 col-md-6 col-lg-4 mb-4"
              }, [
                _createVNode(_component_Skeletor, {
                  width: "100%",
                  height: "430"
                })
              ])
            }), 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.isFriend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPosts, (post) => {
                  return (_openBlock(), _createBlock(_component_PostCard, {
                    key: post._id,
                    post: post,
                    currentUserId: _ctx.currentUser.wpId
                  }, null, 8, ["post", "currentUserId"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}